import React from 'react';

import { EnhancedStore } from '@reduxjs/toolkit';
import { LocaleProvider } from '@yandex-360/orb-components/dist/components/Locale';
import { Provider } from 'react-redux';

import Root from './shared/features/root';
import { User } from './shared/features/user';

export const getRootElement = (store: EnhancedStore, location = '', user: User | null = null) => {
    return (
        <Provider store={store}>
            <LocaleProvider defaultLocale={store.getState().config.appLang}>
                <Root location={location} user={user} />
            </LocaleProvider>
        </Provider>
    );
};
